import React from 'react';
import { connect } from 'react-redux';
import Ax from '../../../components/hoc/Ax';
import Loader from '../../../components/ui/Loader/Loader';
import HttpAPICall from '../../../services/HttpAPICall';
import { INVENTORY_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import Status from '../../../components/ui/Status';
import { Modal } from 'bootstrap';
import ItemViewInList from '../includes/ItemViewInList';
import IndentDetailModal from '../warehouseIndent/IndentDetailModal';
import CurrencyFormatter from '../../../services/CurrencyFormatter';
import POQtyDetail from '../includes/POQtyDetail';
import RaisePurchaseOrder from '../purchaseOrder/RaisePurchaseOrder';
import RequisitionCancel from './RequisitionCancel';
import ItemDetailsModal from '../../items/itemDetails/ItemDetailsModal';
import ConsumptionHistoryModal from '../consumption/ConsumptionHistoryModal';
import POHistoryModal from '../purchaseOrder/POHistoryModal';
import ItemTransactionLedger from '../includes/ItemTransactionLedger';
import RequisitionDocument from './RequisitionDocument';
import { toast } from 'react-toastify';
import download from '../../../services/DownloadFile';
import tapIcon from '../../../services/TapIcon';
import TapSelect from '../../../components/ui/TapSelect';
import HistoryDataModal from '../HistoryDataModal';
import uuid from "react-uuid";
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import TicketDetailModal from '../../transactions/ticketTransaction/TicketDetailModal';

class RequisitionDetail extends React.Component {
    
    constructor(props) {
        super(props);
        this.state = {
            req_item_id: null,
            requisition_loading: false,
            requisitionDetail: null,
            requisitionTransId: null,
            addCommentForm: { status: '', notes: ' ' },
            allAllowedStatus: [],
            addCommentFormSubmitting: false,
            excelDownloading: false,
            // Interchange item state
            interchangeItemData: null,
            interchangeableItemList: [],
            interchangeableListingMeta: null,
            interchangeableTotalListingCount: 0,
            interchangeable_loading: false,
            interchangeable_page: 1,
            saveInterchangeableItemForm: false,
            interchangeItemForm: { notes: '' },
               openedFrom: null,
        };
        
        // Initialize all refs
        this.indentDetailRef = React.createRef();
        this.pOQtyDetailModalRef = React.createRef();
        this.RaisePOModalRef = React.createRef();
        this.cancelledItemModalRef = React.createRef();
        this.itemDetailsRef = React.createRef();
        this.myRef = React.createRef();
        this.interchangebleItemModal = null;
        this.requisitionDetailModal = null;
         this.HistoryRef = React.createRef();
         this.ticketDetailRef        =   React.createRef();
        this.requisitionItemChangeUrl = INVENTORY_API_BASE_URL_2 + '/requisition_item_change';
        this.interchangeItemModalId                 =   uuid();
        this.requisitionDetailModalId                =   uuid();
    }   

    componentDidMount = () => {
        // Only initialize modal if not rendering inline
        if (this.props.renderAs !== 'inline') {
            this.requisitionDetailModal = new Modal(document.getElementById(this.requisitionDetailModalId), {keyboard: false, backdrop: false});
        }
        
        // If transaction_id is passed as prop, load detail
        if (this.props.transaction_id) {
            this.getRequisitionDetail(this.props.transaction_id);
        }
    }

    componentDidUpdate(prevProps) {
        // Reload if transaction_id changes
        if (this.props.transaction_id && this.props.transaction_id !== prevProps.transaction_id) {
            this.getRequisitionDetail(this.props.transaction_id);
        }
    }

    modalReqInit = (transaction_id, options = {}) => {
         
        if (this.requisitionDetailModal) {
            this.requisitionDetailModal.show();
        }
       
        this.getRequisitionDetail(transaction_id);
    }

    getRequisitionDetail = (transaction_id) => {
        this.setState({ requisition_loading: true });
        HttpAPICall.withAthorization('GET', INVENTORY_API_BASE_URL_2 + '/requisition/' + transaction_id, this.props.access_token, null, {}, (resp) => {
            let respData = resp.data;
            this.setState({
                requisitionDetail: respData.data,
                requisitionTransId: respData.data.transaction_id,
                allAllowedStatus: respData.data && respData.data.user_status && respData.data.user_status.length > 0 ? 
                    respData.data.user_status.map((s) => { return {value: s.id, label: s.name}; }) : [],
                addCommentForm: { ...this.state.addCommentForm, status: respData.data.status }
            });
            // Notify parent if callback provided
            if (this.props.onDetailLoaded) {
                this.props.onDetailLoaded(respData.data);
            }
        }).then(() => this.setState({ requisition_loading: false }));
    }

    // View methods
    viewIndentDetailModalInit = (transaction_id) => {
        if (this.indentDetailRef.current) {
            this.indentDetailRef.current.modalIndentInit(transaction_id);
        }
    }
    getTicketDetail     =     (id)      =>    {
        this.ticketDetailRef.current.ticketModalInit(id)
    }
    logisticDetailModal = (val) => {
        if (this.LogisticViewModalRef.current) {
            this.LogisticViewModalRef.current.showModalInit(val);
        }
    }

    viewItemModalInit = (item) => {
        
        if (item && this.itemDetailsRef.current) {
            this.itemDetailsRef.current.modalInit(item);
        }
    }

      viewPOHistoryModalInit                       =   (id )  =>  {
        if (this.state.requisitionDetail) {

            let requisitionData = this.state.requisitionDetail;

            if (id) {
                this.pOQtyDetailModalRef.current.modalInit(id)
            }
        }
         
      }

     viewHistoryModalInit = (data, defaultAction = 'pr_history', extraParams = {}) => {
        if (this.state.requisitionDetail && data && this.HistoryRef.current) {
            let requisitionDetail = this.state.requisitionDetail;
            this.HistoryRef.current.modalHistoryInit(data, {
                warehouse_id: requisitionDetail?.warehouse_id,
                asset_id: requisitionDetail?.asset_id,
                workstation_id: null,
                warehouse_detail: requisitionDetail?.warehouse,
                indent_transaction_id: extraParams.indent_transaction_id || '',
                req_item_id: extraParams.req_item_id || '',
                showTransactionType: extraParams.showTransactionType || false,
                defaultAction: defaultAction,
                historyTypes: [
                    { value: 'pr_history', label: 'PR History' },
                    { value: 'consumption', label: 'Consumption History' },
                    { value: 'po_history', label: 'PO History' },
                    { value: 'transaction_ledger', label: 'Item Transaction Ledger' }
                ]
            });
        }
    }
   

    scrollToComment = () => {
    if (this.myRef.current) {
            this.myRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }




    // Update viewInterchangeableModalInit method
    viewInterchangeableModalInit = (itemdata, key) => {
        console.log(itemdata, 'data');
        if (itemdata) {
            // Store the data with proper structure matching IndentDetailModal
            this.setState({
                interchangeItemData: {
                    ...itemdata,
                    requisition_transaction_id: this.state.requisitionTransId // Ensure this is set
                },
                interchangeItemForm: { notes: '' },
                interchangeableItemList: [],
                interchangeable_loading: true
            }, () => {
                // After state update, get the interchangeable items
                this.getInterChangeableItemList(itemdata?.item?.id, 1, () => {
                    // After data is loaded, show the modal
                    this.showInterchangeModal();
                });
            });
        }
    }

    viewInterchangeableItemJsx = () => {
        // Store data in a local variable to ensure it's accessible
        const data = this.state.interchangeItemData;
        const max_qty = data?.pending_qty || 0;

        return (
            <div className="modal fade" id={this.interchangeItemModalId} tabIndex="-1">
                <div className="modal-dialog modal-lg modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Interchange Item</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        {data && (
                            <div className='p-1 bg-light border-bottom'>
                                <table className='table table-sm mb-0 table-borderless text-sm'>
                                    <tbody>
                                        <tr>
                                            <td>Requisition ID</td>
                                            <th>{this.state.requisitionTransId}</th>
                                        </tr>
                                        <tr>
                                            <td style={{ width: "26%" }}>Item Name</td>
                                            <th>{data.item?.name || ""}</th>
                                        </tr>
                                        <tr>
                                            <td>Item Code</td>
                                            <th>{data.item?.item_code || "-"}</th>
                                        </tr>
                                        <tr>
                                            <td>Req Qty</td>
                                            <th>{data.qty || ''}</th>
                                        </tr>
                                        <tr>
                                            <td>Pending Qty</td>
                                            <th>{data.pending_qty || '0'}</th>
                                        </tr>
                                        {data.indent_data && (
                                            <>
                                                <tr>
                                                    <td>Indent Qty</td>
                                                    <th>{data.indent_data?.indent_need_qty || "-"}</th>
                                                </tr>
                                                <tr>
                                                    <td>Indent Pending Qty</td>
                                                    <th>{data.indent_data?.pending_qty || "-"}</th>
                                                </tr>
                                            </>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        )}

                        <div className="modal-body">
                            <form className="bg-white" onSubmit={this.submitSelectedInterchangeItem} id="requisitionInterchangeItemForm" method="post" encType="multipart/form-data">
                                <table className="table table-hover table-bordered table-responsive bg-white my-3 table-sm">
                                    <thead className="table-secondary">
                                        <tr className="text-center">
                                            <th style={{ "width": '7%' }}>
                                                <input type='checkbox' onChange={this.checkAllInterchangeList} id="all_check_interchange" />
                                            </th>
                                            <th className="text-start">Item Details</th>
                                            <th style={{ width: "13%" }} className="text-end">Qty</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.interchangeable_loading
                                            ? (<tr><td colSpan="6"><Loader /></td></tr>)
                                            : (this.state.interchangeableItemList.length > 0
                                                ? (this.state.interchangeableItemList.map((item, k) => {
                                                    return (
                                                        <tr key={k} className="text-center">
                                                            <td>
                                                                <input type='checkbox'
                                                                    className="interchange_id_checkbox"
                                                                    name="interchangebleItem"
                                                                    value={item.id}
                                                                    data-qty={item?.new_qty || 0}
                                                                />
                                                            </td>
                                                            <td className="text-start">
                                                                <Ax>
                                                                    <b>{item.name}</b> <br />
                                                                    <small>Code: <b>{item.item_code}</b></small> <br />
                                                                    <small>Mfr: <b>{item.manufacturer?.name ?? '-'}</b> (MPN: <b>{item.manufacturer_part_no ?? '-'}</b>)</small>
                                                                </Ax>
                                                            </td>
                                                            <td>
                                                                <input
                                                                    className='form-control form-control-sm text-end'
                                                                    placeholder='Quantity'
                                                                    name="new_qty"
                                                                    type="number"
                                                                    value={item.new_qty || 0}
                                                                    onChange={(e) => {
                                                                        this.state.interchangeableItemList[k] = { ...item, new_qty: e.target.value };
                                                                        this.dynamicInputHandlerByKeyNameVal(e.target.value, 'new_qty', k, 'interchangeableItemList');
                                                                    }}
                                                                    max={max_qty}
                                                                    autoComplete="off"
                                                                    step=".01"
                                                                />
                                                            </td>
                                                        </tr>
                                                    );
                                                }))
                                                : (<tr><td colSpan="6" className="text-center">No Records</td></tr>)
                                            )
                                        }
                                    </tbody>
                                </table>
                                <div className="row align-items-center">
                                    <div className="col-sm-6">
                                        <label htmlFor="notes" className="form-label">Notes</label>
                                        <div>
                                            <textarea
                                                name="notes"
                                                value={this.state.interchangeItemForm.notes}
                                                onChange={(e) => this.formInputHandler(e, 'interchangeItemForm')}
                                                className="form-control"
                                                autoComplete='off'
                                                style={{ height: "100px" }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button type="submit" disabled={this.state.saveInterchangeableItemForm} className="btn btn-primary" form="requisitionInterchangeItemForm">
                                Submit {this.state.saveInterchangeableItemForm ? (<tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin" />) : ''}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // Updated submitSelectedInterchangeItem method
    submitSelectedInterchangeItem = (e) => {
        e.preventDefault();

        // Get the data from state - store it in a variable immediately
        let data = this.state.interchangeItemData;
        console.log('Interchange data from state:', data);

        // If data is null, try to get it from the props or use a different approach
        if (!data) {
            // Try to get data from the props or from the component instance
            if (this._interchangeData) {
                data = this._interchangeData;
                console.log('Using stored interchange data:', data);
            } else {
                toast.error('No item data found', { position: toast.POSITION.TOP_RIGHT });
                return;
            }
        }

        let interchangeItemCheckboxCollections = document.getElementsByClassName('interchange_id_checkbox');
        let allSelectedItems = [];
        let totalQty = 0;

        if (interchangeItemCheckboxCollections && interchangeItemCheckboxCollections.length > 0) {
            for (let i = 0; i < interchangeItemCheckboxCollections.length; i++) {
                if (interchangeItemCheckboxCollections[i].checked) {
                    let item_id = interchangeItemCheckboxCollections[i].value;
                    // Get quantity from input field in the same row
                    let qtyInput = interchangeItemCheckboxCollections[i].closest('tr').querySelector('input[name="new_qty"]');
                    let qty = qtyInput ? qtyInput.value : interchangeItemCheckboxCollections[i].getAttribute("data-qty");
                    allSelectedItems.push({ item_id: item_id, qty: qty });
                    totalQty += parseFloat(qty) || 0;
                }
            }
        }

        const pendingQty = data.pending_qty || 0;

        if (allSelectedItems.length === 0) {
            toast.error('Please select atleast one Item', { position: toast.POSITION.TOP_RIGHT });
            return;
        }

        if (allSelectedItems.some(i => parseFloat(i.qty) <= 0)) {
            toast.error('Every Item\'s qty must be more than 0.', { position: toast.POSITION.TOP_RIGHT });
            return;
        }

        if (allSelectedItems.some(i => i.qty === '' || i.qty === null)) {
            toast.error('Every Item\'s qty should not be blank', { position: toast.POSITION.TOP_RIGHT });
            return;
        }

        if (totalQty > pendingQty) {
            toast.error('Total Qty cannot be more than pending Qty', { position: toast.POSITION.TOP_RIGHT });
            return;
        }

        // Build form data
        let frmData = {
            req_item_id: data.req_item_id,
            transaction_id: data.requisition_transaction_id || this.state.requisitionTransId,
            item_id: data.item?.id || data.item_id,
            replace_items: allSelectedItems,
            notes: this.state.interchangeItemForm.notes || ''
        };

        console.log('Submitting form data:', frmData);

        this.setState({ saveInterchangeableItemForm: true });

        HttpAPICall.withAthorization('PUT', this.requisitionItemChangeUrl || INVENTORY_API_BASE_URL_2 + '/requisition_item_change', this.props.access_token, {}, { ...frmData }, (response) => {
            toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
            if (this.interchangebleItemModal) {
                this.interchangebleItemModal.hide();
            }
            this.getRequisitionDetail(data.requisition_transaction_id || this.state.requisitionTransId);
            if (this.props.onUpdate) {
                this.props.onUpdate();
            }
        }).then(() => this.setState({ saveInterchangeableItemForm: false })).catch((error) => {
            console.error('Error submitting interchange:', error);
            this.setState({ saveInterchangeableItemForm: false });
        });
    }

    // Updated viewInterchangeableModalInit to store data in a class property
    viewInterchangeableModalInit = (itemdata, key) => {
        console.log(itemdata, 'data');
        if (itemdata) {
            // Store data in a class property to ensure it persists
            this._interchangeData = {
                ...itemdata,
                requisition_transaction_id: this.state.requisitionTransId
            };

            this.setState({
                interchangeItemData: this._interchangeData,
                interchangeItemForm: { notes: '' },
                interchangeableItemList: [],
                interchangeable_loading: true
            }, () => {
                this.getInterChangeableItemList(itemdata?.item?.id, 1, () => {
                    this.showInterchangeModal();
                });
            });
        }
    }
    // Update getInterChangeableItemList method to accept callback
    getInterChangeableItemList = (id, page = 1, callback = null) => {
        this.setState({ interchangeable_loading: true, interchangeable_page: page });
        HttpAPICall.withAthorization('GET', INVENTORY_API_BASE_URL_2 + '/item/interchangeable_item/' + id, this.props.access_token, {}, {}, (resp) => {
            let respData = resp.data;
            console.log("Interchangeable items loaded:", respData.data); // Debug log
            this.setState({
                interchangeableItemList: respData.data || [],
                interchangeableListingMeta: respData.meta,
                interchangeableTotalListingCount: respData.meta ? respData.meta.total : 0,
            }, () => {
                if (callback) callback();
            });
        }).then(() => this.setState({ interchangeable_loading: false }));
    }

    // Update showInterchangeModal method
    showInterchangeModal = () => {
        const modalElement = document.getElementById(this.interchangeItemModalId);
        if (modalElement) {
            // Re-initialize the modal instance each time to ensure it works
            if (this.interchangebleItemModal) {
                this.interchangebleItemModal.dispose();
            }
            this.interchangebleItemModal = new Modal(modalElement, { keyboard: false, backdrop: false });
            this.interchangebleItemModal.show();
            console.log("Modal shown"); // Debug log
        }
    }

   
    checkAllInterchangeList = () => {
        let interchangeItemCheckboxCollections = document.getElementsByClassName('interchange_id_checkbox');
        const allChecked = document.getElementById('all_check_interchange')?.checked || false;
        if (interchangeItemCheckboxCollections && interchangeItemCheckboxCollections.length > 0) {
            for (let i = 0; i < interchangeItemCheckboxCollections.length; i++) {
                interchangeItemCheckboxCollections[i].checked = allChecked;
            }
        }
    }


    // Comment/Status update
    submitUpdateCommentForm = (e) => {
        e.preventDefault();
        this.setState({ addCommentFormSubmitting: true });
        let frmData = {
            ...this.state.addCommentForm,
            transaction_id: this.state.requisitionTransId
        };
        HttpAPICall.withAthorization('PUT', INVENTORY_API_BASE_URL_2 + '/requisition/comment', this.props.access_token, {}, { ...frmData }, (response) => {
            toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
            this.getRequisitionDetail(this.state.requisitionTransId);
            if (this.props.onUpdate) {
                this.props.onUpdate();
            }
            this.setState({ addCommentForm: { ...this.state.addCommentForm, notes: ' ' } });
        }).then(() => this.setState({ addCommentFormSubmitting: false }));
    }

    // Download handlers
    downloadPdfHandler = () => {
        this.setState({ excelDownloading: true });
        HttpAPICall.withAthorization('GET', INVENTORY_API_BASE_URL_2 + '/requisition/' + this.state.requisitionTransId, this.props.access_token, { download: "download" }, {}, (response) => {
            download.file(response.data.file_path);
        }).then(() => this.setState({ excelDownloading: false }));
    }

    // Get action modals for parent
    getRaisePOModal = () => this.RaisePOModalRef;
    getCancelModal = () => this.cancelledItemModalRef;

    // Render detail content (reused for both modal and inline)
    renderDetailContent = () => {
        let requisition = this.state.requisitionDetail;
        
        if (this.state.requisition_loading) {
            return <Loader />;
        }
        
        if (!requisition) {
            return <div className="text-center p-5">No requisition selected</div>;
        }

        return (
            <div>
                {/* Header Info */}
                <table className="table table-bordered bg-white">
                    <thead className="table-secondary">
                        <tr>
                            <th style={{ width: "33%" }}>ID</th>
                            <th style={{ width: "33%" }}>Date</th>
                            <th style={{ width: "33%" }}>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{requisition.transaction_id}</td>
                            <td>{requisition.transaction_date_display}</td>
                            <td className="align-middle">
                                {requisition.status_data ? requisition.status_data.name : ''}
                            </td>
                        </tr>
                    </tbody>
                </table>

                {/* Details */}
                <table className="table table-hover table-bordered table-responsive bg-white mb-0">
                    <tbody>
                        <tr>
                            <td style={{ width: "33%" }}>Warehouse</td>
                            <td colSpan={2}>
                                {requisition.warehouse ? (
                                    <div>
                                        <b>{requisition.warehouse.name} ({requisition.warehouse.code})</b>
                                        <br />
                                        <div className='pt-1'>
                                            Address: {requisition.warehouse.address1 ? requisition.warehouse.address1 + ", " : ""}
                                            {requisition.warehouse.address2 ? requisition.warehouse.address2 + ", " : ""}
                                            {requisition.warehouse.landmark ? requisition.warehouse.landmark + ", " : ""}
                                            {requisition.warehouse.city ? requisition.warehouse.city + ". " : "-"} <br />
                                            State: <b>{requisition.warehouse.state_name}</b> <br />
                                            GSTIN: {requisition?.warehouse?.gstin ?? "-"} <br />
                                            Site: {requisition.site ? requisition.site.site_name : "-"}
                                        </div>
                                    </div>
                                ) : "-"}
                            </td>
                        </tr>
                        <tr>
                            <td>Title</td>
                            <td colSpan={2}>{requisition.title ?? "-"}</td>
                        </tr>
                        <tr>
                            <td>Priority</td>
                            <td colSpan={2} className='text-capitalize'>{requisition.priority ?? "-"}</td>
                        </tr>
                        <tr>
                            <td>Due Date</td>
                            <td colSpan={2}>{requisition.due_date_display ?? "-"}</td>
                        </tr>
                        <tr>
                            <td>Tag Users</td>
                            <td colSpan={2}>
                                {requisition.usersList && requisition.usersList.map((u, idx) => (
                                    <div key={idx}>{u.full_name}</div>
                                ))}
                            </td>
                        </tr>
                        <tr>
                            <td>PR For</td>
                            <td colSpan={2}>
                                {requisition.pr_for === "asset" ? "Asset" :
                                    requisition.pr_for === "workstation" ? "Workstation" :
                                        requisition.pr_for === "employee" ? "Employee" :
                                            requisition.pr_for === "sub_assembly" ? "Sub Assembly" :
                                                requisition.pr_for === "customer" ? "Customer" : "-"}
                            </td>
                        </tr>
                        {requisition.pr_for && (
                            <tr>
                                <td style={{ width: "33%" }}>
                                    {requisition.pr_for === "asset" ? "Asset" :
                                        requisition.pr_for === "workstation" ? "Workstation" :
                                            requisition.pr_for === "employee" ? "Employee" :
                                                requisition.pr_for === "sub_assembly" ? "Sub Assembly" :
                                                    requisition.pr_for === "customer" ? "Customer" : ""}
                                </td>
                                <th colSpan={2}>
                                    {requisition.pr_for === "asset" && requisition.assetData ? requisition.assetData.name :
                                        requisition.pr_for === "workstation" && requisition.workstation ? requisition.workstation.workstation_name :
                                            requisition.pr_for === "employee" && requisition.employee ? requisition.employee.name :
                                                requisition.pr_for === "sub_assembly" && requisition.sub_assembly ? requisition.sub_assembly.name :
                                                    requisition.pr_for === "customer" && requisition.customer ? requisition.customer.name : "-"}
                                </th>
                            </tr>
                        )}
                        {this.props.settings && this.props.settings['ticket_purchase_requisition'] === "Y" && (
                            <tr>
                                <td>Ticket</td>
                                <td colSpan={2}>
                                    {requisition.ticket ? (
                                        <Link onClick={() => this.getTicketDetail(requisition.ticket.activity_id)}>
                                            {`${requisition.ticket.activity_id} : ${requisition.ticket.header}`}
                                        </Link>
                                    ) : ''}
                                </td>
                            </tr>
                        )}
                        <tr>
                            <td>Indent</td>
                            <th colSpan={2} className='link-primary cursor_pointer'>
                                {
                                    this.props?.openedFrom ? (
                                        <span>
                                            {requisition?.warehouse_indent?.transaction_id}
                                        </span>
                                    ) : (
                                        <span
                                            className="link-primary cursor_pointer"
                                            onClick={() =>
                                                this.viewIndentDetailModalInit(
                                                    requisition?.warehouse_indent?.transaction_id
                                                )
                                            }
                                        >
                                            {requisition?.warehouse_indent?.transaction_id}
                                        </span>
                                    )
                                }
                            </th>
                        </tr>
                    </tbody>
                </table>

                {/* Items Table */}
                <table className="table table-sm table-bordered table-responsive bg-white my-3 table-fixed" id="dataTable">
                    <thead className="table-secondary">
                        <tr className="text-end">
                            <th scope="col" style={{ width: "5%" }} className="text-center">
                                <input type='checkbox' onChange={this.checkAllList} id="all_check_requisition" />
                            </th>
                            <th scope="col" style={{ width: "32%" }} className="text-start">Item Details</th>
                            <th scope="col" style={{ width: "13%" }} className="text-start">Quantity, Unit & Rate</th>
                            <th scope="col" style={{ width: "8%" }}>Indent Qty</th>
                            <th scope="col" style={{ width: "8%" }}>Req. Qty</th>
                            <th scope="col" style={{ width: "8%" }}>PO Qty</th>
                            <th scope="col" style={{ width: "8%" }}>Received</th>
                            <th scope="col" style={{ width: "8%" }}>Cancelled</th>
                            <th scope="col" style={{ width: "8%" }}>Pending</th>
                        </tr>
                    </thead>
                    <tbody>
                        {requisition?.items?.length > 0 ?
                            requisition.items.map((i, k) => (
                                <tr key={k}>
                                    <td className='text-center'>
                                        {k + 1}
                                        <br /><br />
                                        <input type='checkbox'
                                            className="req_item_id_checkbox"
                                            name="foo"
                                            value={i.req_item_id}
                                            data-warehouseId={requisition.warehouse_id}
                                            data-statusLevel={requisition.status_data && requisition.status_data.level}
                                            data-pendingQty={i.pending_qty}
                                            data-itemid={i.item.id}
                                        />
                                    </td>
                                    <td>
                                        {i.item ? (
                                            <div className='row'>
                                                <div className='col-sm-10'>
                                                    <ItemViewInList item={i.item} remark={i.remark} viewItemModal={() => this.viewItemModalInit(i.item)} />
                                                </div>
                                              {this.props.renderAs == 'inline'  && <div className='col-sm-2 text-end'>
                                                    <tapIcon.imageIcon icon={tapIcon.ListActionIcon} alt="action-icon" className="img-fluid" data-bs-toggle="dropdown" href="#" role="button" aria-expanded="false" />
                                                    <ul className="dropdown-menu">
                                                         <li>
                                                            <a href="#" className="dropdown-item" onClick={() => this.viewHistoryModalInit(i.item, 'pr_history', {  req_item_id: i.req_item_id })}>
                                                                View History
                                                            </a>
                                                        </li>
                                                        {this.props.permissions && this.props.permissions.includes('isc-item-Interchangeable-edit') &&
                                                            <li><a href="#" className="dropdown-item" onClick={() => this.viewInterchangeableModalInit(i, k)}>Interchange Item</a></li>
                                                        }
                                                    </ul>
                                                </div>}
                                            </div>
                                        ) : null}
                                    </td>
                                    <td>
                                        <div className="fs12">
                                            {i.qty} {i.item?.measuring_unit?.name ?? ""} @ {i.currency} {i.rate} ({i.currency}.{i.item_amount})
                                        </div>
                                    </td>
                                    <td className="text-end">{i.indent_data ? i.indent_data.indent_need_qty : "-"}</td>
                                    <td className="text-end">{i.qty}</td>
                                    <td className="text-end">
                                        <a href="#" className={'link-primary cursor_pointer'} onClick={() => this.viewPOHistoryModalInit(i.req_item_id)}>
                                            {i.current_po_qty}
                                        </a>
                                    </td>
                                    <td className="text-end">{i.received_qty}</td>
                                    <td className="text-end">{i.cancelled_qty}</td>
                                    <td className="text-end">{i.pending_qty}</td>
                                </tr>
                            ))
                            : <tr><td className='text-center' colSpan={9}>No Record</td></tr>
                        }
                    </tbody>
                </table>

                {/* Notes and Totals */}
                <div className="row align-items-center">
                    <div className="col-sm-6">
                        <label htmlFor="notes" className="form-label">Notes</label>
                        <div>{requisition.notes ?? "-"}</div>
                    </div>
                    <div className="col-sm-6">
                        <table className="table table-borderless">
                            <tbody>
                                <tr className="subtotal_bg_color">
                                    <th>Sub-Total</th>
                                    <td className='float-end'>
                                        <CurrencyFormatter currencyCode={this.props.default_currency} amount={requisition.total_amount ? (requisition.total_amount - requisition.total_tax).toFixed(2) : 0.00} />
                                    </td>
                                </tr>
                                <tr className="subtotal_bg_color">
                                    <th>Total Tax</th>
                                    <td className='float-end'>
                                        <CurrencyFormatter currencyCode={this.props.default_currency} amount={requisition.total_tax ?? 0} />
                                    </td>
                                </tr>
                                <tr className="subtotal_bg_color">
                                    <th>Final Total</th>
                                    <td className='float-end'>
                                        <CurrencyFormatter currencyCode={this.props.default_currency} amount={requisition.total_amount ? requisition.total_amount : 0} />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                {this.props.renderAs == 'inline' && (
                    <>
                        {/* Documents */}
                        <RequisitionDocument requisitionDetails={requisition} getRequisitionDetail={(id) => this.getRequisitionDetail(id)} />
                        <hr />

                        {/* Comments */}
                        {requisition.status != 5 && requisition.status != 6 && (
                            <div>
                                <div className="tab_content_wrapper" ref={this.myRef}>
                                    <span className="content_heading">Comments & History</span>
                                </div>
                                <form onSubmit={this.submitUpdateCommentForm}>
                                    <div className="my-3 row">
                                        <label className="col-sm-3 col-form-label">Change status to</label>
                                        <div className="col-sm-5">
                                            <TapSelect
                                                changeEvent={(selectedOption) => {
                                                    this.tapSelectChange(selectedOption, 'addCommentForm', 'status');
                                                }}
                                                value={this.state.allAllowedStatus.find(s => s.value == this.state.addCommentForm.status)}
                                                options={this.state.allAllowedStatus}
                                                isSearchable={false}
                                                placeholder="Please Select Status"
                                                isDisabled={!this.props.permissions || !this.props.permissions.includes('isc-purchase-requisition-status-change')}
                                            />
                                        </div>
                                    </div>
                                    <div className="my-2">
                                        <label className="form-label">Comments</label>
                                        <textarea
                                            name="notes"
                                            value={this.state.addCommentForm.notes}
                                            onChange={(e) => this.formInputHandler(e, 'addCommentForm')}
                                            className="form-control"
                                            placeholder="Please Add a comment"
                                            required
                                            style={{ height: "100px" }}
                                        />
                                    </div>
                                    <div className="col-12 text-end">
                                        <button type="submit" disabled={this.state.addCommentFormSubmitting} className="btn btn-primary mx-2">
                                            Update {this.state.addCommentFormSubmitting && (<tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin ms-2" />)}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        )}
                        <hr />

                        {/* Comments List */}
                        <div className="my-1">
                            {requisition.comments && requisition.comments.map((c, k) => (
                                <Ax key={k}>
                                    <div className="row">
                                        {c.msg ? <div className="col-sm-8" dangerouslySetInnerHTML={{ __html: c.msg }} /> : <div className='col-sm-8'>-</div>}
                                        <div className="col-sm-4 text-end">
                                            <tapIcon.imageIcon icon={tapIcon.CalenderIcon} className="img-fluid pr-5 fs12" alt="item-action" />
                                            <span> {c.created_at_display}</span>
                                        </div>
                                        <div className="col-sm-8 my-1">{c.notes}</div>
                                    </div>
                                    <hr />
                                </Ax>
                            ))}
                        </div>
                    </>
                )}
            </div>
        );
    }

    checkAllList = () => {
        let reqItemCheckboxCollections = document.getElementsByClassName('req_item_id_checkbox');
        const allChecked = document.getElementById('all_check_requisition')?.checked || false;
        if (reqItemCheckboxCollections && reqItemCheckboxCollections.length > 0) {
            for (let i = 0; i < reqItemCheckboxCollections.length; i++) {
                reqItemCheckboxCollections[i].checked = allChecked;
            }
        }
    }

    formInputHandler = (e, formName) => {
        this.setState({
            [formName]: {
                ...this.state[formName],
                [e.target.name]: e.target.value
            }
        });
    }

    tapSelectChange = (selectedOption, formName, fieldName) => {
        this.setState({
            [formName]: {
                ...this.state[formName],
                [fieldName]: selectedOption ? selectedOption.value : null
            }
        });
    }

    dynamicInputHandlerByKeyNameVal = (value, keyName, index, stateKey) => {
        const updatedList = [...this.state[stateKey]];
        updatedList[index] = { ...updatedList[index], [keyName]: value };
        this.setState({ [stateKey]: updatedList });
    }

    viewInterchangeableItemJsx = () => {
        // Store data in a local variable to ensure it's accessible
        const data = this.state.interchangeItemData;
        const max_qty = data?.pending_qty || 0;

        return (
            <div className="modal fade" id={this.interchangeItemModalId} tabIndex="-1">
                <div className="modal-dialog modal-lg modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Interchange Item</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        {data && (
                            <div className='p-1 bg-light border-bottom'>
                                <table className='table table-sm mb-0 table-borderless text-sm'>
                                    <tbody>
                                        <tr>
                                            <td>Requisition ID</td>
                                            <th>{this.state.requisitionTransId}</th>
                                        </tr>
                                        <tr>
                                            <td style={{ width: "26%" }}>Item Name</td>
                                            <th>{data.item?.name || ""}</th>
                                        </tr>
                                        <tr>
                                            <td>Item Code</td>
                                            <th>{data.item?.item_code || "-"}</th>
                                        </tr>
                                        <tr>
                                            <td>Req Qty</td>
                                            <th>{data.qty || ''}</th>
                                        </tr>
                                        <tr>
                                            <td>Pending Qty</td>
                                            <th>{data.pending_qty || '0'}</th>
                                        </tr>
                                        {data.indent_data && (
                                            <>
                                                <tr>
                                                    <td>Indent Qty</td>
                                                    <th>{data.indent_data?.indent_need_qty || "-"}</th>
                                                </tr>
                                                <tr>
                                                    <td>Indent Pending Qty</td>
                                                    <th>{data.indent_data?.pending_qty || "-"}</th>
                                                </tr>
                                            </>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        )}

                        <div className="modal-body">
                            <form className="bg-white" onSubmit={this.submitSelectedInterchangeItem} id={`${this.interchangeItemModalId}Form`} method="post" encType="multipart/form-data">
                                <table className="table table-hover table-bordered table-responsive bg-white my-3 table-sm">
                                    <thead className="table-secondary">
                                        <tr className="text-center">
                                            <th style={{ "width": '7%' }}>
                                                <input type='checkbox' onChange={this.checkAllInterchangeList} id="all_check_interchange" />
                                            </th>
                                            <th className="text-start">Item Details</th>
                                            <th style={{ width: "13%" }} className="text-end">Qty</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.interchangeable_loading
                                            ? (<tr><td colSpan="6"><Loader /></td></tr>)
                                            : (this.state.interchangeableItemList.length > 0
                                                ? (this.state.interchangeableItemList.map((item, k) => {
                                                    return (
                                                        <tr key={k} className="text-center">
                                                            <td>
                                                                <input type='checkbox'
                                                                    className="interchange_id_checkbox"
                                                                    name="interchangebleItem"
                                                                    value={item.id}
                                                                    data-qty={item?.new_qty}
                                                                />
                                                            </td>
                                                            <td className="text-start">
                                                                <Ax>
                                                                    <b>{item.name}</b> <br />
                                                                    <small>Code: <b>{item.item_code}</b></small> <br />
                                                                    <small>Mfr: <b>{item.manufacturer?.name ?? '-'}</b> (MPN: <b>{item.manufacturer_part_no ?? '-'}</b>)</small>
                                                                </Ax>
                                                            </td>
                                                            <td>
                                                                <input
                                                                    className='form-control form-control-sm text-end'
                                                                    placeholder='Quantity'
                                                                    name="new_qty"
                                                                    type="number"
                                                                    value={item.new_qty}
                                                                    onChange={(e) => {
                                                                        this.state.interchangeableItemList[k] = { ...item, new_qty: e.target.value };
                                                                        this.dynamicInputHandlerByKeyNameVal(e.target.value, 'new_qty', k, 'interchangeableItemList');
                                                                    }}
                                                                    max={max_qty}
                                                                    autoComplete="off"
                                                                    step=".01"
                                                                />
                                                            </td>
                                                        </tr>
                                                    );
                                                }))
                                                : (<tr><td colSpan="6" className="text-center">No Records</td></tr>)
                                            )
                                        }
                                    </tbody>
                                </table>
                                <div className="row align-items-center">
                                    <div className="col-sm-6">
                                        <label htmlFor="notes" className="form-label">Notes</label>
                                        <div>
                                            <textarea
                                                name="notes"
                                                value={this.state.interchangeItemForm.notes}
                                                onChange={(e) => this.formInputHandler(e, 'interchangeItemForm')}
                                                className="form-control"
                                                autoComplete='off'
                                                style={{ height: "100px" }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button type="submit" disabled={this.state.saveInterchangeableItemForm} className="btn btn-primary" form={`${this.interchangeItemModalId}Form`}>
                                Submit {this.state.saveInterchangeableItemForm ? (<tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin" />) : ''}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    // Modal rendering (for backward compatibility)
    reqDetailJsx = () => {
        console.log(this.state.requisitionTransId,this.state.requisitionDetail)
        return (
            <div className="modal fade" id={this.requisitionDetailModalId} tabIndex="-1">
                <div className="modal-dialog modal-lg modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Purchase Requisition Detail: {this.state.requisitionTransId ?? "-"}</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            {this.renderDetailContent()}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        if (this.props.renderAs === 'inline') {
            // Render as inline component (for list view)
            return (
                <div className="requisition-detail-inline">
                    {this.renderDetailContent()}
                    
                    {/* Child modals */}
                    {!this.props.openedFrom && <><IndentDetailModal ref={this.indentDetailRef} />
                        <POQtyDetail ref={this.pOQtyDetailModalRef} />
                        <RequisitionCancel ref={this.cancelledItemModalRef} requisitionTransId={this.state.requisitionTransId} getRequisitionDetail={this.getRequisitionDetail} />
                        <RaisePurchaseOrder parentProps={this.props.parentProps} ref={this.RaisePOModalRef} requisitionDetail={this.state.requisitionDetail} />
                        <HistoryDataModal ref={this.HistoryRef} onLogisticClick={this.logisticDetailModal} />

                    </>}
                    <ItemDetailsModal ref={this.itemDetailsRef} />
              
                    
                    {/* Interchangeable Modal */}
                    {this.viewInterchangeableItemJsx()}
                      <TicketDetailModal ref={this.ticketDetailRef}/>
                </div>
            );
        }

        // Render as modal
        return (
            <div>
                {this.reqDetailJsx()}
                {!this.props.openedFrom && <><IndentDetailModal ref={this.indentDetailRef} />
                    <POQtyDetail ref={this.pOQtyDetailModalRef} /></>}

                <ItemDetailsModal ref={this.itemDetailsRef} />
                {/* Interchangeable Modal */}
                {this.viewInterchangeableItemJsx()}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        access_token: state.auth.access_token,
        default_currency: state.app && state.app.default_currency ? state.app.default_currency : 'INR',
        permissions: state.app.acl_info && state.app.acl_info.permissions ? state.app.acl_info.permissions : [],
        settings: state.app.setting
    };
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(RequisitionDetail);